<template>
	<!-- 监理月报（CCSI） -->
	<div class="mod-config">
		<el-card style="height: 100%;">
			<el-row>
				<span style="text-align:left;font-weight:bold">监理月报</span>
			</el-row>
			<el-row class="fixed-number-row">
				<div
					style="display: flex; justify-content: flex-end; align-items: center; font-weight: bold; gap: 6px; height: 100%;">
					编号：
					<span v-if="!basicVisible">{{ dataForm.monthlyName }}</span>
					<el-input v-else v-model="dataForm.monthlyName" placeholder="请输入" class="monthly-input"
						style="width: 100px;" />
				</div>
			</el-row>
			<el-row style="text-align:center;font-weight:bold;font-size: 17px;">
				<span>
					监理工作月报
				</span>
				<div style="margin: 5px 0;">{{ dataForm.showMonthlyDate }}</div>
			</el-row>
			<el-form :model="dataForm" :rules="dataRule" ref="dataForm" :inline="true" class="border-form">
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="工程名称" class="item">
							<el-input class="sp-input" v-model="dataForm.projectName" placeholder="请输入"
								v-if="basicVisible" style="width: 100%;"></el-input>
							<span v-if="!basicVisible">
								{{ dataForm.projectName }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="工作控制号" class="item">
							<span class="set_span">
								{{ dataForm.workNo }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="委托单位" class="item">
							<el-input class="sp-input" v-model="dataForm.projectEntrust" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectEntrust }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="设计单位" class="item">
							<el-input class="sp-input" v-model="dataForm.projectDesignCompany" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectDesignCompany }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="建造单位" class="item">
							<el-input class="sp-input" v-model="dataForm.contractCompany" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.contractCompany }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="监理单位" class="item">
							<el-input class="sp-input" v-model="dataForm.companyName" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.companyName }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="12" class="col-set_border">
						<el-form-item label-width="120px" label="报告人" class="item">
							<el-input class="sp-input" v-model="dataForm.reportMan" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.reportMan }}
							</span>
						</el-form-item>
					</el-col>
					<el-col :span="12">
						<el-form-item label-width="120px" label="项目总监" class="item">
							<el-input class="sp-input" v-model="dataForm.projectDirector" placeholder="请输入"
								v-if="basicVisible"></el-input>
							<span class="set_span" v-if="!basicVisible">
								{{ dataForm.projectDirector }}
							</span>
						</el-form-item>
					</el-col>
				</el-row>
				<el-row class="set_border">
					<el-col :span="23" class="selBtnGroup">
						<el-button class="btn" type="primary" size="small" @click="updateBasicHandle()"
							v-if="!basicVisible">修改</el-button>
						<el-button class="btn" type="primary" size="small" @click="saveBasicHandle()"
							v-if="basicVisible">保存</el-button>
						<el-button class="rebtn" size="small" @click="cancelBasicUpdateHandle()"
							v-if="basicVisible">取消</el-button>
					</el-col>
				</el-row>
				<table>
					<tr>
						<td :rowSpan="8"
							style="width: 3%; background-color: #E1F1FF; text-align:center; vertical-align:middle;">
							<span
								style="font-size:13px;display:inline-block; width: 28px; word-break: break-all; white-space:normal; line-height:1.6;">
								形象进度完成情况
							</span>
						</td>
						<td style="width: 8%;">
							<span class="mod_span">计划完成</span>
						</td>
						<td :colSpan="4">
							<draggable v-model="dataForm.planCompleteList" @start="onDragStart('000001')"
								@update="onDragEnd">
								<el-row v-for="(planComplete, index) in dataForm.planCompleteList"
									:key="'planCom' + index">
									<el-tooltip v-if="planComplete.updUserName && planComplete.updDate" placement="top"
										effect="light" :content="`${planComplete.updUserName} ${planComplete.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;">
											<!-- <el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col> -->
											<el-col :span="24" class="set_nonS" :style="getFileItemBgStyle(planComplete)">
												<el-col :span="21" class="desc_span">
													{{ planComplete.fileName }}
												</el-col>
												<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
												</el-button>
												<el-col :span="2" class="operate_col">
													<el-button type="text" style="margin-right: 10px;" class="desc_btn"
														v-if="planComplete.showButton == 1"
														@click="addOrUpdateSituation(planComplete.recNo, '000001')">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="planComplete.showButton == 1"
														@click="deleteMonthlyReportFile(planComplete.recNo, '000001')">
														×
													</el-button>
												</el-col>
											</el-col>
										</el-col>
									</el-tooltip>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in planComplete.photoList"
											:key="'planPhoto' + index1" style="margin-top: 20px;"
											v-if="planComplete.photoList != undefined && planComplete.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-row>
							</draggable>
							<el-row>
								<el-col :span="24" style="margin:10px 20px 5px 10px; text-align: right;">
									<el-tooltip content="添加内容描述" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000001')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="上期数据参考" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="lastRecordRefHandle('000001')">
											<i class="el-icon-document btn-icon"></i>
										</el-button>
									</el-tooltip>
								</el-col>
							</el-row>
						</td>
					</tr>
					<tr>
						<td>
							<span class="mod_span">实际完成</span>
						</td>
						<td :colSpan="4">
							<draggable v-model="dataForm.actualCompleteList" @start="onDragStart('000002')"
								@update="onDragEnd">
								<el-row v-for="(actualComplete, index) in dataForm.actualCompleteList"
									:key="'actualCom' + index">
									<el-tooltip v-if="actualComplete.updUserName && actualComplete.updDate"
										placement="top" effect="light"
										:content="`${actualComplete.updUserName} ${actualComplete.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;">
											<!-- <el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col> -->
											<el-col :span="24" class="set_nonS" :style="getFileItemBgStyle(actualComplete)">
												<el-col :span="21" class="desc_span">
													{{ actualComplete.fileName }}
												</el-col>
												<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
												</el-button>
												<el-col :span="2" class="operate_col">
													<el-button type="text" style="margin-right: 10px;" class="desc_btn"
														v-if="actualComplete.showButton == 1"
														@click="addOrUpdateSituation(actualComplete.recNo, '000002')">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="actualComplete.showButton == 1"
														@click="deleteMonthlyReportFile(actualComplete.recNo, '000002')">
														×
													</el-button>
												</el-col>
											</el-col>
										</el-col>
									</el-tooltip>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in actualComplete.photoList"
											:key="'actualPhoto' + index1" style="margin-top: 20px;"
											v-if="actualComplete.photoList != undefined && actualComplete.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-row>
							</draggable>
							<el-row>
								<el-col :span="24" style="margin:10px 20px 5px 10px; text-align: right;">
									<el-tooltip content="添加内容描述" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000002')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="上期数据参考" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="lastRecordRefHandle('000002')">
											<i class="el-icon-document btn-icon"></i>
										</el-button>
									</el-tooltip>
								</el-col>
							</el-row>
						</td>
					</tr>
					<tr>
						<td>
							<span class="mod_span">原因分析</span>
						</td>
						<td :colSpan="4">
							<draggable v-model="dataForm.causeAnalysisList" @start="onDragStart('000003')"
								@update="onDragEnd">
								<el-row v-for="(causeAnalysis, index) in dataForm.causeAnalysisList"
									:key="'cause' + index">
									<el-tooltip v-if="causeAnalysis.updUserName && causeAnalysis.updDate"
										placement="top" effect="light"
										:content="`${causeAnalysis.updUserName} ${causeAnalysis.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;">
											<!-- <el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col> -->
											<el-col :span="24" class="set_nonS" :style="getFileItemBgStyle(causeAnalysis)">
												<el-col :span="21" class="desc_span">
													{{ causeAnalysis.fileName }}
												</el-col>
												<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
												</el-button>
												<el-col :span="2" class="operate_col">
													<el-button type="text" style="margin-right: 10px;" class="desc_btn"
														v-if="causeAnalysis.showButton == 1"
														@click="addOrUpdateSituation(causeAnalysis.recNo, '000003')">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="causeAnalysis.showButton == 1"
														@click="deleteMonthlyReportFile(causeAnalysis.recNo, '000003')">
														×
													</el-button>
												</el-col>
											</el-col>
										</el-col>
									</el-tooltip>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in causeAnalysis.photoList"
											:key="'causePhoto' + index1" style="margin-top: 20px;"
											v-if="causeAnalysis.photoList != undefined && causeAnalysis.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-row>
							</draggable>
							<el-row>
								<el-col :span="24" style="margin:10px 20px 5px 10px; text-align: right;">
									<el-tooltip content="添加内容描述" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000003')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="上期数据参考" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="lastRecordRefHandle('000003')">
											<i class="el-icon-document btn-icon"></i>
										</el-button>
									</el-tooltip>
								</el-col>
							</el-row>
						</td>
					</tr>
					<tr>
						<td class="sit_label">
							<span class="mod_span">
								专题报告/<br />
								会议纪要
							</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">{{ dataForm.specialAndMeetSum }}份</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">内容提要</span>
						</td>
						<td>
							<draggable v-model="dataForm.specialAndMeetList" @start="onDragStart('000400')"
								@update="onDragEnd">
								<el-row v-for="(specialAndMeet, index) in dataForm.specialAndMeetList"
									:key="'speAndMeet' + index">
									<el-tooltip v-if="specialAndMeet.updUserName && specialAndMeet.updDate"
										placement="top" effect="light"
										:content="`${specialAndMeet.updUserName} ${specialAndMeet.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;">
											<!-- <el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col> -->
											<el-col :span="24" class="set_nonS" :style="getFileItemBgStyle(specialAndMeet)">
												<el-col :span="21" class="desc_span">
													{{ specialAndMeet.fileName }}
												</el-col>
												<el-col :span="2">
													<el-button type="text" class="desc_btn"
														style="margin-left: 43.5% !important;"
														v-if="specialAndMeet.showButton == 1"
														@click="addOrUpdateSituation(specialAndMeet.recNo, specialAndMeet.dataType)">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="specialAndMeet.showButton == 1"
														@click="deleteMonthlyReportFile(specialAndMeet.recNo, specialAndMeet.dataType)">
														×
													</el-button>
												</el-col>
											</el-col>
										</el-col>
									</el-tooltip>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in specialAndMeet.photoList"
											:key="'specialAndMeetPhoto' + index1" style="margin-top: 20px;"
											v-if="specialAndMeet.photoList != undefined && specialAndMeet.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-row>
							</draggable>
							<el-row>
								<el-col :span="24" style="margin:10px 20px 5px 10px; text-align: right;">
									<el-tooltip content="添加专题报告" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000401')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="添加会议纪要" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000402')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="选择专题报告" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="selectSpecialReportHandle('000401')">
											<i class="el-icon-search btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="选择会议纪要" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="selectMeetInfoHandle('000402')">
											<i class="el-icon-search btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="上期数据参考" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="lastRecordRefHandle('000400')">
											<i class="el-icon-document btn-icon"></i>
										</el-button>
									</el-tooltip>
								</el-col>
							</el-row>
						</td>
					</tr>
					<tr>
						<td class="sit_label">
							<span class="mod_span">质量签证</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">{{ dataForm.qualityVisaSum }}份</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">内容提要</span>
						</td>
						<td>
							<draggable v-model="dataForm.qualityVisaList" @start="onDragStart('000005')"
								@update="onDragEnd">
								<el-row v-for="(qualityVisa, index) in dataForm.qualityVisaList"
									:key="'qualityVisa' + index">
									<el-tooltip v-if="qualityVisa.updUserName && qualityVisa.updDate" placement="top"
										effect="light" :content="`${qualityVisa.updUserName} ${qualityVisa.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;">
											<!-- <el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col> -->
											<el-col :span="24" class="set_nonS" :style="getFileItemBgStyle(qualityVisa)">
												<el-col :span="22" class="desc_span">
													{{ qualityVisa.fileName }}
												</el-col>
												<el-col :span="1">
													<!-- <el-button type="text" class="desc_btn"
														style="margin-left: 43.5% !important;"
														v-if="qualityVisa.showButton == 1"
														@click="addOrUpdateSituation(qualityVisa.recNo, qualityVisa.dataType)">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="qualityVisa.showButton == 1"
														@click="deleteMonthlyReportFile(qualityVisa.recNo, qualityVisa.dataType)">
														×
													</el-button> -->
													<el-button type="text" class="desc_btn"
														style="margin-left: 43.5% !important;"
														@click="searchQualityVisa(qualityVisa.recNo)">
														<i class="el-icon-search"></i></el-button>
												</el-col>
											</el-col>
										</el-col>
									</el-tooltip>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in qualityVisa.photoList"
											:key="'qualityVisaPhoto' + index1" style="margin-top: 20px;"
											v-if="qualityVisa.photoList != undefined && qualityVisa.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-row>
							</draggable>
							<!-- <el-row>
								<el-col :span="24" style="margin:10px 20px 5px 10px; text-align: right;">
									<el-tooltip content="添加质量签证" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000005')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="上期数据参考" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="lastRecordRefHandle('000005')">
											<i class="el-icon-document btn-icon"></i>
										</el-button>
									</el-tooltip>
								</el-col>
							</el-row> -->
						</td>
					</tr>
					<tr>
						<td class="sit_label">
							<span class="mod_span">
								向建造单<br />
								位发出的<br />
								通知、指<br />
								示
							</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">{{ dataForm.issueContactAndNoticeNum }}份</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">内容提要</span>
						</td>
						<td>
							<draggable v-model="dataForm.issueContactAndNoticeList" @start="onDragStart('000600')"
								@update="onDragEnd">
								<el-row v-for="(contactAndNotice, index) in dataForm.issueContactAndNoticeList"
									:key="'contactAndNotice' + index">
									<el-tooltip v-if="contactAndNotice.updUserName && contactAndNotice.updDate"
										placement="top" effect="light"
										:content="`${contactAndNotice.updUserName} ${contactAndNotice.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;">
											<!-- <el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col> -->
											<el-col :span="24" class="set_nonS" :style="getFileItemBgStyle(contactAndNotice)">
												<el-col :span="21" class="desc_span">
													{{ contactAndNotice.fileName }}
												</el-col>
												<el-col :span="2">
													<el-button type="text" class="desc_btn"
														style="margin-left: 43.5% !important;"
														v-if="contactAndNotice.showButton == 1"
														@click="addOrUpdateSituation(contactAndNotice.recNo, contactAndNotice.dataType)">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="contactAndNotice.showButton == 1"
														@click="deleteMonthlyReportFile(contactAndNotice.recNo, contactAndNotice.dataType)">
														×
													</el-button>
												</el-col>
											</el-col>
										</el-col>
									</el-tooltip>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in contactAndNotice.photoList"
											:key="'contactAndNoticePhoto' + index1" style="margin-top: 20px;"
											v-if="contactAndNotice.photoList != undefined && contactAndNotice.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-row>
							</draggable>
							<el-row>
								<el-col :span="24" style="margin:10px 20px 5px 10px; text-align: right;">
									<el-tooltip content="添加联系单" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000601')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="添加通知单" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000602')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="选择联系单" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="selectContactHandle('000601', '1')">
											<i class="el-icon-search btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="选择通知单" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="selectContactHandle('000602', '2')">
											<i class="el-icon-search btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="上期数据参考" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="lastRecordRefHandle('000600')">
											<i class="el-icon-document btn-icon"></i>
										</el-button>
									</el-tooltip>
								</el-col>
							</el-row>
						</td>
					</tr>
					<tr>
						<td class="sit_label">
							<span class="mod_span">建造单位<br />提出的各<br />种报告</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">{{ dataForm.anyReportSum }}份</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">内容提要</span>
						</td>
						<td>
							<draggable v-model="dataForm.anyReportList" @start="onDragStart('000007')"
								@update="onDragEnd">
								<el-row v-for="(anyReport, index) in dataForm.anyReportList" :key="'anyReport' + index">
									<el-tooltip v-if="anyReport.updUserName && anyReport.updDate" placement="top"
										effect="light" :content="`${anyReport.updUserName} ${anyReport.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;">
											<!-- <el-col :span="1">
												<i class="el-icon-position"></i>
											</el-col> -->
											<el-col :span="24" class="set_nonS" :style="getFileItemBgStyle(anyReport)">
												<el-col :span="21" class="desc_span">
													{{ anyReport.fileName }}
												</el-col>
												<el-col :span="2">
													<el-button type="text" class="desc_btn"
														style="margin-left: 43.5% !important;"
														v-if="anyReport.showButton == 1"
														@click="addOrUpdateSituation(anyReport.recNo, anyReport.dataType)">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="anyReport.showButton == 1"
														@click="deleteMonthlyReportFile(anyReport.recNo, anyReport.dataType)">
														×
													</el-button>
												</el-col>
											</el-col>
										</el-col>
									</el-tooltip>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in anyReport.photoList"
											:key="'anyReportPhoto' + index1" style="margin-top: 20px;"
											v-if="anyReport.photoList != undefined && anyReport.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-row>
							</draggable>
							<el-row>
								<el-col :span="24" style="margin:10px 20px 5px 10px; text-align: right;">
									<el-tooltip content="添加建造单位提出的各种报告" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000007')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="上期数据参考" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="lastRecordRefHandle('000007')">
											<i class="el-icon-document btn-icon"></i>
										</el-button>
									</el-tooltip>
								</el-col>
							</el-row>
						</td>
					</tr>
					<tr>
						<td class="sit_label">
							<span>付款签证</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">{{ dataForm.paymentVisaSum }}份</span>
						</td>
						<td style="width:9%">
							<span class="mod_span">内容提要</span>
						</td>
						<td>
							<draggable v-model="dataForm.paymentVisaList" @start="onDragStart('000008')"
								@update="onDragEnd">
								<el-row v-for="(paymentVisa, index) in dataForm.paymentVisaList"
									:key="'paymentVisa' + index">
									<el-tooltip v-if="paymentVisa.updUserName && paymentVisa.updDate" placement="top"
										effect="light" :content="`${paymentVisa.updUserName} ${paymentVisa.updDate}`"
										:enterable="false">
										<el-col :span="24" style="cursor: pointer;">
											<el-col :span="24" class="set_nonS" :style="getFileItemBgStyle(paymentVisa)">
												<el-col :span="21" class="desc_span">
													{{ paymentVisa.fileName }}
												</el-col>
												<el-col :span="2">
													<el-button type="text" class="desc_btn"
														style="margin-left: 43.5% !important;"
														v-if="paymentVisa.showButton == 1"
														@click="addOrUpdateSituation(paymentVisa.recNo, paymentVisa.dataType)">
														<i class="el-icon-edit"></i></el-button>
													<el-button type="text" class="desc_btn"
														v-if="paymentVisa.showButton == 1"
														@click="deleteMonthlyReportFile(paymentVisa.recNo, paymentVisa.dataType)">
														×
													</el-button>
												</el-col>
											</el-col>
										</el-col>
									</el-tooltip>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in paymentVisa.photoList"
											:key="'paymentVisaPhoto' + index1" style="margin-top: 20px;"
											v-if="paymentVisa.photoList != undefined && paymentVisa.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-row>
							</draggable>
							<el-row>
								<el-col :span="24" style="margin:10px 20px 5px 10px; text-align: right;">
									<el-tooltip content="添加付款签证" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="addOrUpdateSituation('', '000008')">
											<i class="el-icon-plus btn-icon"></i>
										</el-button>
									</el-tooltip>
									<el-tooltip content="上期数据参考" placement="top" effect="light">
										<el-button class="week_btn" type="primary" size="small"
											@click="lastRecordRefHandle('000008')">
											<i class="el-icon-document btn-icon"></i>
										</el-button>
									</el-tooltip>
								</el-col>
							</el-row>
						</td>
					</tr>
				</table>
				<div class="titleDiv" style="margin-bottom: 0px;">本月工程情况评述</div>
				<el-row :span="24" v-for="(progressKind, index) in dataForm.progressKindList" :key="'pk' + index">
					<div class="titleDiv_second" style="margin-top:10px;margin-bottom: 5px;">
						<span>{{ progressKind.titleName }}</span>
					</div>
					<el-row>
						<draggable v-model="progressKind.recordAndTableList" @start="onDragStart(progressKind.dataType)"
							@update="onDragEnd">
							<el-row :span="24" v-for="(recordTable, index) in progressKind.recordAndTableList"
								:key="'sit' + index">
								<el-tooltip
									v-if="(recordTable.dataKind == undefined || recordTable.dataKind == '' || recordTable.dataKind == '1') && recordTable.record.updUserName && recordTable.record.updDate"
									placement="top" effect="light"
									:content="`${recordTable.record.updUserName} ${recordTable.record.updDate}`"
									:enterable="false">
									<el-col :span="24"
										v-if="recordTable.dataKind == undefined || recordTable.dataKind == '' || recordTable.dataKind == '1'">
										<el-col :span="1">
											<i class="el-icon-position"></i>
										</el-col>
										<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(recordTable.record)">
											<el-col :span="22" class="desc_span">
												{{ recordTable.record.fileName }}
											</el-col>
											<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
											</el-button>
											<el-col :span="1" class="operate_col">
												<el-button type="text" style="margin-right: 10px;" class="desc_btn"
													v-if="recordTable.record.showButton == 1"
													@click="addOrUpdateSituation(recordTable.record.recNo, progressKind.dataType, progressKind.progressKindName)">
													<i class="el-icon-edit"></i></el-button>
												<el-button type="text" class="desc_btn"
													v-if="recordTable.record.showButton == 1"
													@click="deleteMonthlyReportFile(recordTable.record.recNo, progressKind.dataType)">
													×
												</el-button>
											</el-col>
										</el-col>
										<el-col :span="23" style="width:90%;margin-left:170px">
											<div v-for="(photo, index1) in recordTable.record.photoList"
												:key="'progressKindPhoto' + index1" style="margin-top: 20px;"
												v-if="recordTable.record.photoList != undefined && recordTable.record.photoList.length > 0">
												<el-col :span="9">
													<div style="margin:20px 20px 20px 20px ">
														<el-image style="height: 250px;" :src="photo.compressedPathUri"
															fit='contain'></el-image>
													</div>
												</el-col>
											</div>
										</el-col>
									</el-col>
								</el-tooltip>
								<el-col :span="24" v-else-if="recordTable.dataKind != undefined && recordTable.dataKind != '' && recordTable.dataKind == '2'
									&& recordTable.showTable != undefined && recordTable.showTable != '' && recordTable.showTable == '3'"">
									<el-row>
										<el-col :span="24" class="cp_sc_div">
									<span>
										<!-- {{ recordTable.conProgress.majorName }} - {{recordTable.conProgress.itemName }} -->
									</span>
									<el-button type="text" class="desc_btn" style="margin-top:2px"
										@click="deleteMonthlyReportFile(recordTable.conProgress.recNo, progressKind.dataType)">
										×
									</el-button>
								</el-col>
								<el-table :row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable"
									border :header-cell-style="headClass"
									v-if="recordTable.conProgress.progress.headers != undefined && recordTable.conProgress.progress.headers.length > 0"
									:data="recordTable.conProgress.progress.recordList" header-align="center"
									header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }"
									style="margin-left:0px;">
									<el-table-column label="NO." width="60" align="center" type="index">
									</el-table-column>
									<el-table-column v-for="(v, idx) in recordTable.conProgress.progress.headers"
										v-if="idx == 0" :key="idx" :label="v.subProgressName" :prop="v.colName"
										align="left" min-width="120px">
										<template slot-scope="scope">
											<span>{{ scope.row.itemName }}</span>
										</template>
									</el-table-column>
									<el-table-column v-for="(v, idx) in recordTable.conProgress.progress.headers"
										v-if="recordTable.conProgress.progress.headers.length > 1 && idx >= 1"
										:key="idx" :label="v.subProgressName" :prop="v.colName" align="center">
										<template slot-scope="scope">
											<span>{{ scope.row.contentList[idx].colValue }}</span>
										</template>
									</el-table-column>
									<el-table-column label="备注" align="center">
										<template slot-scope="scope">
											<span>{{ scope.row.remark }}</span>
										</template>
									</el-table-column>
								</el-table>
							</el-row>
							</el-col>
							<el-col :span="24" v-else-if="recordTable.dataKind != undefined && recordTable.dataKind != '' && recordTable.dataKind == '2'
								&& recordTable.showTable != undefined && recordTable.showTable != '' && recordTable.showTable == '4'">
								<el-row>
									<el-col :span="24" class="cp_sc_div">
										<!-- 左侧文字 -->
										<span>
											<!-- {{ recordTable.conProgress.majorName }} - {{recordTable.conProgress.itemName }} -->
										</span>
										<!-- 右侧关闭按钮 -->
										<el-button type="text" style="margin-top:2px"
											@click="deleteMonthlyReportFile(recordTable.recNo, progressKind.dataType)">
											×
										</el-button>
									</el-col>
									<el-table max-height="600" :row-class-name="tableRowClassName"
										:span-method="(params) => objectNodeSpanMethod(params, recordTable.progressNode.records)"
										ref="dataListTable" class="dataListTable" border
										:data="recordTable.progressNode.records" header-align="center"
										header-cell-class-name="dataListTHeader" :cell-style="{ padding: '0px' }"
										:header-cell-style="headClass" style="margin-left:0px;font-size: 12px;">
										<el-table-column v-for="(v, idx) in recordTable.progressNode.headers" :key="idx"
											v-if="recordTable.progressNode.headers != undefined && recordTable.progressNode.headers.length > 0 && v.nodeId === '0'"
											:label="v.nodeName" :prop="v.nodeId" align="center" width="130px">
											<template slot-scope="scope">
												<span style="font-weight:bolder">
													{{ scope.row.subjectName }}
												</span>
											</template>
										</el-table-column>
										<el-table-column v-for="(v, idx) in recordTable.progressNode.headers" :key="idx"
											v-if="recordTable.progressNode.headers != undefined && recordTable.progressNode.headers.length > 0 && v.nodeId === '1'"
											:label="v.nodeName" :prop="v.nodeId" align="center" width="60px">
											<template slot-scope="scope">
												<span style="font-weight:bolder">
													{{ scope.row.title }}
												</span>
											</template>
										</el-table-column>
										<el-table-column v-for="(v, idx) in recordTable.progressNode.headers" :key="idx"
											v-if="recordTable.progressNode.headers != undefined && recordTable.progressNode.headers.length > 0 && idx > 1"
											:label="v.nodeName" :prop="v.nodeId" align="center">
											<template slot-scope="scope">
												<span>
													{{ scope.row.contentList[idx - 2].colValue }}
												</span>
											</template>
										</el-table-column>
									</el-table>
								</el-row>
							</el-col>
					</el-row>
					</draggable>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="进度对比表" placement="top" effect="light"
							v-if="progressKind.progressKindId === '01'">
							<el-button class="week_btn" type="primary" size="small"
								@click="addProgressRecordHandle(progressKind.dataType)">
								<i class="el-icon-s-marketing btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="添加内容描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', progressKind.dataType, progressKind.progressKindName)">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="选择描述内容" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="chooseProgressKindHandle(progressKind.dataType, progressKind.progressKindId, progressKind.progressKindName)">
								<i class="el-icon-search btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="添加表格" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addProgressKindTableHandle(progressKind.dataType, progressKind.progressKindId)">
								<i class="el-icon-s-grid  btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle(progressKind.dataType, progressKind.progressKindName)">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				</el-row>
				<div class="titleDiv">{{ dataForm.safeQualityIndex }}安全质量情况
				</div>
				<el-row style="margin-bottom: 5px;">
					<div class="seTitleDiv">
						<span>1.停止点检查情况：</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.stopPointList" @start="onDragStart('050100')" @update="onDragEnd">
					<el-row :span="24" v-for="(stopPoint, index) in dataForm.stopPointList" :key="'stop' + index">
						<el-tooltip
							v-if="(stopPoint.dataKind == undefined || stopPoint.dataKind == '' || stopPoint.dataKind == '1') && stopPoint.updUserName && stopPoint.updDate"
							placement="top" effect="light" :content="`${stopPoint.updUserName} ${stopPoint.updDate}`"
							:enterable="false">
							<el-col :span="24"
								v-if="stopPoint.dataKind == undefined || stopPoint.dataKind == '' || stopPoint.dataKind == '1'">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(stopPoint)">
									<el-col :span="22" class="desc_span">
										{{ stopPoint.fileName }}
									</el-col>
									<!-- 占位 -->
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="stopPoint.showButton == 1"
											@click="addOrUpdateSituation(stopPoint.recNo, '050100')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="stopPoint.showButton == 1"
											@click="deleteMonthlyReportFile(stopPoint.recNo, '050100')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in stopPoint.photoList" :key="'stopPointPhoto' + index1"
										style="margin-top: 20px;"
										v-if="stopPoint.photoList != undefined && stopPoint.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
						<el-col :span="24"
							v-else-if="stopPoint.dataKind != undefined && stopPoint.dataKind != '' && stopPoint.dataKind == '2' && stopPoint.showTable == '1'">
							<el-col :span="24" class="cp_sc_div">
								<span>
									<!-- 报验表 -->
								</span>
								<el-button type="text" class="desc_btn" style="margin-top:2px"
									@click="deleteMonthlyReportFile(stopPoint.recNo, '050100')">
									×
								</el-button>
							</el-col>
							<el-table :row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable"
								border :header-cell-style="headClass" :data="stopPoint.testRecordList"
								header-align="center" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }" style="margin-left:10px;">
								<el-table-column label="NO." width="60" align="center" type="index">
								</el-table-column>
								<el-table-column prop="partsName" label="部件" align="left" width="100">
								</el-table-column>
								<el-table-column prop="probContext" label="报验内容" align="left" min-width="150">
								</el-table-column>
								<el-table-column prop="testConclusionName" label="结果" align="left" width="120">
								</el-table-column>
								<el-table-column prop="sutContent" label="报验情况" align="left" min-width="150">
								</el-table-column>
								<el-table-column label="备注" width="200" align="center">
									<template slot-scope="scope">
										<span>{{ scope.row.remark }}</span>
									</template>
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加内容描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '050100')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="添加数据明细表格" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addStopPointTableHandle('050100')">
								<i class="el-icon-s-grid  btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('050100')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 5px;">
					<div class="seTitleDiv" style="margin-top:10px">
						<span>2.巡检情况：</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.inspectionSituationList" @start="onDragStart('050200')"
					@update="onDragEnd">
					<el-row v-for="(inspection, index) in dataForm.inspectionSituationList" :key="'inspection' + index">
						<el-tooltip
							v-if="inspection.dataKind == undefined || inspection.dataKind == '' || inspection.dataKind == '1'"
							placement="top" effect="light" :content="`${inspection.updUserName} ${inspection.updDate}`"
							:enterable="false">
							<el-col :span="24"
								v-if="inspection.dataKind == undefined || inspection.dataKind == '' || inspection.dataKind == '1'">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(inspection)">
									<el-col :span="22" class="desc_span">
										{{ inspection.fileName }}
									</el-col>
									<!-- 占位 -->
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="inspection.showButton == 1"
											@click="addOrUpdateSituation(inspection.recNo, '050200')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="inspection.showButton == 1"
											@click="deleteMonthlyReportFile(inspection.recNo, '050200')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in inspection.photoList"
										:key="'inspectionPhoto' + index1" style="margin-top: 20px;"
										v-if="inspection.photoList != undefined && inspection.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
						<el-col :span="24"
							v-else-if="inspection.dataKind != undefined && inspection.dataKind != '' && inspection.dataKind == '2' && inspection.showTable == '2'">
							<el-col :span="24" class="cp_sc_div">
								<!-- 左侧文字 -->
								<span>
									<!-- 汇总表 -->
								</span>
								<!-- 右侧关闭按钮 -->
								<el-button type="text" class="desc_btn" style="margin-top:2px"
									@click="deleteMonthlyReportFile(inspection.recNo, '050200')">
									×
								</el-button>
							</el-col>
							<el-table :row-class-name="tableRowClassName" ref="dataListTable" class="dataListTable"
								border :header-cell-style="headClass" :data="inspection.inspectionList"
								header-align="center" header-cell-class-name="dataListTHeader"
								:cell-style="{ padding: '0px' }" style="margin-left:10px;font-size: 12px;">
								<el-table-column label="NO." width="60" align="center" type="index">
								</el-table-column>
								<el-table-column prop="sutContent" label="巡检发现的问题及整改意见" align="left" min-width="200">
								</el-table-column>
								<el-table-column prop="inspectionTimeStr" label="提出时间" align="center" width="150">
								</el-table-column>
								<el-table-column prop="closeTimeStr" label="封闭时间" align="center" width="150">
								</el-table-column>
								<el-table-column prop="closeMan" label="封闭人" align="center" width="150">
								</el-table-column>
							</el-table>
						</el-col>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加内容描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '050200')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="添加数据明细表格" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addInspectionTableHandle('050200')">
								<i class="el-icon-s-grid  btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('050200')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 5px;">
					<div class=" seTitleDiv" style="margin-top:10px">
						<span>3.监理工作联系单和通知单（不一致项报告）处理及跟踪情况：</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.contactAndNoticeList" @start="onDragStart('050300')" @update="onDragEnd">
					<el-row :span="24" v-for="(contactAndNotice, index) in dataForm.contactAndNoticeList"
						:key="'contactAndNotice' + index">
						<el-tooltip v-if="contactAndNotice.updUserName && contactAndNotice.updDate" placement="top"
							effect="light" :content="`${contactAndNotice.updUserName} ${contactAndNotice.updDate}`"
							:enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(contactAndNotice)">
									<el-col :span="22" class="desc_span">
										{{ contactAndNotice.fileName }}
									</el-col>
									<!-- 占位 -->
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="contactAndNotice.showButton == 1"
											@click="addOrUpdateSituation(contactAndNotice.recNo, '050300')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="contactAndNotice.showButton == 1"
											@click="deleteMonthlyReportFile(contactAndNotice.recNo, '050300')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in contactAndNotice.photoList"
										:key="'contactAndNoticePhoto' + index1" style="margin-top: 20px;"
										v-if="contactAndNotice.photoList != undefined && contactAndNotice.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '050300')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="选择联系单" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="chooseContactHandle('050300', '1')">
								<i class="el-icon-search btn-icon"></i>联系单
							</el-button>
						</el-tooltip>
						<el-tooltip content="选择通知单" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="chooseContactHandle('050300', '2')">
								<i class="el-icon-search btn-icon"></i>通知单
							</el-button>
						</el-tooltip>
						<el-tooltip content="添加汇总情况" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small" @click="addSummaryHandle()">
								<i class="el-icon-s-data"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('050300')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 5px;">
					<div class="seTitleDiv" style="margin-top:10px">
						<span>4.签收及审查文件情况：</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.fileCheckRecords" @start="onDragStart('050400')" @update="onDragEnd">
					<el-row :span="24" v-for="(fileCheck, index) in dataForm.fileCheckRecords"
						:key="'fileCheck' + index">
						<el-tooltip v-if="fileCheck.updUserName && fileCheck.updDate" placement="top" effect="light"
							:content="`${fileCheck.updUserName} ${fileCheck.updDate}`" :enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(fileCheck)">
									<el-col :span="22" class="desc_span">
										{{ fileCheck.fileName }}
									</el-col>
									<!-- 占位 -->
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="fileCheck.showButton == 1"
											@click="addOrUpdateSituation(fileCheck.recNo, '050400')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="fileCheck.showButton == 1"
											@click="deleteMonthlyReportFile(fileCheck.recNo, '050400')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in fileCheck.photoList" :key="'fileCheckPhoto' + index1"
										style="margin-top: 20px;"
										v-if="fileCheck.photoList != undefined && fileCheck.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -5px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '050400')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('050400')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<el-row style="margin-bottom: 5px;">
					<div class="seTitleDiv" style="margin-top:10px">
						<span>5.会议及会谈情况</span>
					</div>
				</el-row>
				<draggable v-model="dataForm.meetingList" @start="onDragStart('050500')" @update="onDragEnd">
					<el-row v-for="(meeting, index) in dataForm.meetingList" :key="'meet' + index">
						<el-tooltip v-if="meeting.updUserName && meeting.updDate" placement="top" effect="light"
							:content="`${meeting.updUserName} ${meeting.updDate}`" :enterable="false">
							<el-col :span="24" style="cursor: pointer;">
								<el-col :span="1">
									<i class="el-icon-position"></i>
								</el-col>
								<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(meeting)">
									<el-col :span="22" class="desc_span">
										{{ meeting.fileName }}
									</el-col>
									<el-button v-preventReClick type="text" size="small" class="desc_zw"> . </el-button>
									<el-col :span="1" class="operate_col">
										<el-button type="text" style="margin-right: 10px;" class="desc_btn"
											v-if="meeting.showButton == 1"
											@click="addOrUpdateSituation(meeting.recNo, '050500')">
											<i class="el-icon-edit"></i></el-button>
										<el-button type="text" class="desc_btn" v-if="meeting.showButton == 1"
											@click="deleteMonthlyReportFile(meeting.recNo, '050500')">
											×
										</el-button>
									</el-col>
								</el-col>
								<el-col :span="23" style="width:90%;margin-left:170px">
									<div v-for="(photo, index1) in meeting.photoList" :key="'meetingPhoto' + index1"
										style="margin-top: 20px;"
										v-if="meeting.photoList != undefined && meeting.photoList.length > 0">
										<el-col :span="9">
											<div style="margin:20px 20px 20px 20px ">
												<el-image style="height: 250px;" :src="photo.compressedPathUri"
													fit='contain'></el-image>
											</div>
										</el-col>
									</div>
								</el-col>
							</el-col>
						</el-tooltip>
					</el-row>
				</draggable>
				<el-row>
					<el-col :span="24" style="margin:10px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加会议与座谈内容 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '050500')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="从监理会议模块提取 " placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="selectMeetingHandle('050500')">
								<i class="el-icon-search btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('050500')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div class="titleDiv">本月监理工作小结</div>
				<el-row>
					<draggable v-model="dataForm.workSummaryList" @start="onDragStart('111111')" @update="onDragEnd">
						<el-row :span="24" v-for="(workSummary, index) in dataForm.workSummaryList"
							:key="'summary' + index">
							<el-tooltip v-if="workSummary.updUserName && workSummary.updDate" placement="top"
								effect="light" :content="`${workSummary.updUserName} ${workSummary.updDate}`"
								:enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(workSummary)">
										<el-col :span="22" class="desc_span">
											{{ workSummary.fileName }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="workSummary.showButton == 1"
												@click="addOrUpdateSituation(workSummary.recNo, '111111')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="workSummary.showButton == 1"
												@click="deleteMonthlyReportFile(workSummary.recNo, '111111')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in workSummary.photoList"
											:key="'workSummaryPhoto' + index1" style="margin-top: 20px;"
											v-if="workSummary.photoList != undefined && workSummary.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:5px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '111111')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('111111')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
				<div class="titleDiv">下月监理工作安排</div>
				<el-row>
					<draggable v-model="dataForm.nextMonthWorkPlanList" @start="onDragStart('222222')"
						@update="onDragEnd">
						<el-row :span="24" v-for="(nextMonth, index) in dataForm.nextMonthWorkPlanList"
							:key="'next' + index">
							<el-tooltip v-if="nextMonth.updUserName && nextMonth.updDate" placement="top" effect="light"
								:content="`${nextMonth.updUserName} ${nextMonth.updDate}`" :enterable="false">
								<el-col :span="24" style="cursor: pointer;">
									<el-col :span="1">
										<i class="el-icon-position"></i>
									</el-col>
									<el-col :span="23" class="set_nonS" :style="getFileItemBgStyle(nextMonth)">
										<el-col :span="22" class="desc_span">
											{{ nextMonth.fileName }}
										</el-col>
										<!-- 占位 -->
										<el-button v-preventReClick type="text" size="small" class="desc_zw"> .
										</el-button>
										<el-col :span="1" class="operate_col">
											<el-button type="text" style="margin-right: 10px;" class="desc_btn"
												v-if="nextMonth.showButton == 1"
												@click="addOrUpdateSituation(nextMonth.recNo, '222222')">
												<i class="el-icon-edit"></i></el-button>
											<el-button type="text" class="desc_btn" v-if="nextMonth.showButton == 1"
												@click="deleteMonthlyReportFile(nextMonth.recNo, '222222')">
												×
											</el-button>
										</el-col>
									</el-col>
									<el-col :span="23" style="width:90%;margin-left:170px">
										<div v-for="(photo, index1) in nextMonth.photoList"
											:key="'nextMonthPhoto' + index1" style="margin-top: 20px;"
											v-if="nextMonth.photoList != undefined && nextMonth.photoList.length > 0">
											<el-col :span="9">
												<div style="margin:20px 20px 20px 20px ">
													<el-image style="height: 250px;" :src="photo.compressedPathUri"
														fit='contain'></el-image>
												</div>
											</el-col>
										</div>
									</el-col>
								</el-col>
							</el-tooltip>
						</el-row>
					</draggable>
					<el-col :span="24" style="margin:5px 20px -10px 10px; text-align: right;">
						<el-tooltip content="添加描述" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="addOrUpdateSituation('', '222222')">
								<i class="el-icon-plus btn-icon"></i>
							</el-button>
						</el-tooltip>
						<el-tooltip content="上期数据参考" placement="top" effect="light">
							<el-button class="week_btn" type="primary" size="small"
								@click="lastRecordRefHandle('222222')">
								<i class="el-icon-document btn-icon"></i>
							</el-button>
						</el-tooltip>
					</el-col>
				</el-row>
			</el-form>
		</el-card>

		<special-report-select v-if="specialReportSelectVisible" ref="specialReportSelect"
			@refreshDataList="getProjectMonthlyReportDetail"></special-report-select>
		<meeting-select v-if="meetingSelectVisible" ref="meetingSelect"
			@selectMeetingItems="margeSelectMeetingItems"></meeting-select>
		<add-or-update-situation v-if="addOrUpdateSituationVisible" ref="addOrUpdateSituation"
			@refreshDataList="getProjectMonthlyReportDetail"></add-or-update-situation>
		<choose-progress-record v-if="chooseProgressKindVisible" ref="chooseProgressRecord"
			@refreshDataList="getProjectMonthlyReportDetail"></choose-progress-record>
		<last-record-ref v-if="lastRecordRefVisible" ref="lastRecordRef"
			@refreshDataList="getProjectMonthlyReportDetail"></last-record-ref>
		<add-progress-table v-if="addProgressKindTableVisible" ref="addProgressTable"
			@refreshDataList="getProjectMonthlyReportDetail"></add-progress-table>
		<choose-contact v-if="chooseContactVisible" ref="chooseContact"
			@refreshDataList="getProjectMonthlyReportDetail"></choose-contact>
		<meet-info-select v-if="meetInfoSelectVisible" ref="meetInfoSelect"
			@refreshDataList="getProjectMonthlyReportDetail"></meet-info-select>
		<contact-select v-if="selectContactVisible" ref="contactSelect"
			@refreshDataList="getProjectMonthlyReportDetail"></contact-select>
		<search-quality-visa v-if="searchQualityVisaVisible" ref="searchQualityVisa"
			@refreshDataList="getProjectMonthlyReportDetail"></search-quality-visa>
	</div>
</template>
<script>
import addImg from "@/assets/images/addImg.png"
import $common from "@/utils/common.js";
import SpecialReportSelect from './special-report-select.vue'
import MeetingSelect from './meeting-select.vue'
import MeetInfoSelect from './meet-info-select.vue'
import ContactSelect from './contact-select.vue'
import AddOrUpdateSituation from './add-or-update-situation.vue'
import ChooseProgressRecord from './choose-progress-record.vue'
import LastRecordRef from './last-record-ref.vue'
import AddProgressTable from './add-progress-table.vue'
import ChooseContact from './project-monthly-choose-contact.vue'
import SearchQualityVisa from './search_quality_visa.vue'
import draggable from 'vuedraggable';

export default {
	data() {
		return {
			basicVisible: false,
			addOrUpdateVisible: false,
			specialReportSelectVisible: false,
			meetInfoSelectVisible: false,
			meetingSelectVisible: false,
			selectContactVisible: false,
			searchQualityVisaVisible: false,
			photoFlag: 0,
			addImg: addImg,
			recNo: '',
			action: '',
			photoList: [],
			enclosureFileList: [],
			workNo: $common.getItem("workNo"),
			dataRule: {},
			dataForm: {
			},
			draggedItem: {},
			draggedPhotoItem: {},
			recNos: [],
			addOrUpdateMeetingVisible: false,
			addOrUpdateSituationVisible: false,
			chooseProgressKindVisible: false,
			lastRecordRefVisible: false,
			addProgressKindTableVisible: false,
			chooseContactVisible: false,
			photoType: '',
			photoRecNo: '',
			contentIdx: '',
			menuId: 'basic',
			nodeList: [],
			headers: [],
			addFlg: false,
			updateFlg: false,
			meetDataType: '',
			updateDataType: '',
			updateIndex: '',
			updateIndex1: '',
			updateIndex2: '',
			refDataType: ''
		};
	},
	components: {
		SpecialReportSelect,
		MeetingSelect,
		// AddOrUpdateMeeting,
		AddOrUpdateSituation,
		draggable,
		ChooseProgressRecord,
		AddProgressTable,
		LastRecordRef,
		ChooseContact,
		MeetInfoSelect,
		ContactSelect,
		SearchQualityVisa
	},
	mounted() {
		this.recNo = this.$route.query.recNo;
		this.getProjectMonthlyReportDetail()
	},
	methods: {
		getFileItemBgStyle(item) {
			if (item && item.oriRecNo) {
				return { backgroundColor: 'rgb(249 248 209 / 69%)' };
			}
			return {};
		},
		updateBasicHandle() {
			this.basicVisible = true;
		},
		cancelBasicUpdateHandle() {
			this.basicVisible = false;
			this.getProjectMonthlyReportInfo()
		},
		saveBasicHandle() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/update",
				method: 'post',
				data: this.$http.adornData({
					recNo: this.recNo,
					workNo: this.workNo,
					monthlyName: this.dataForm.monthlyName,
					reportMan: this.dataForm.reportMan,
					reportTime: this.dataForm.reportTime,
					projectName: this.dataForm.projectName,
					projectEntrust: this.dataForm.projectEntrust,
					contractCompany: this.dataForm.contractCompany,
					projectDesignCompany: this.dataForm.projectDesignCompany,
					companyName: this.dataForm.companyName,
					projectDirector: this.dataForm.projectDirector,
					reportMan: this.dataForm.reportMan,
				})
			}).then(({
				data
			}) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getProjectMonthlyReportInfo()
					this.basicVisible = false;
				}
			})
		},
		getProjectMonthlyReportInfo() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/getProjectMonthlyReportInfo/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.recNo = data.body.recNo
					this.dataForm.projectName = data.body.projectName
					this.dataForm.monthlyName = data.body.monthlyName
					this.dataForm.projectEntrust = data.body.projectEntrust
					this.dataForm.projectDesignCompany = data.body.projectDesignCompany
					this.dataForm.contractCompany = data.body.contractCompany
					this.dataForm.companyName = data.body.companyName
					this.dataForm.projectDirector = data.body.projectDirector
					this.dataForm.reportMan = data.body.reportMan
				}
			});
		},
		getProjectMonthlyReportDetail() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/getProjectMonthlyReportDetail/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm = data.body;
				}
			});
		},
		tableRowClassName({ row, rowIndex }) {
			return $common.tableScnenRowClassName({ row, rowIndex });
		},
		getCurrentDate() {
			//获取当前时间并打印
			let yy = new Date().getFullYear();
			let mm = new Date().getMonth() + 1;
			let dd = new Date().getDate();
			if (mm < 10) {
				mm = '0' + mm;
			}
			return yy + '.' + mm + '.' + dd;
		},
		extractFileName(fileName) {
			let index = fileName.lastIndexOf(".");
			return fileName.substr(0, index)
		},
		saveWeeklyFileList(weekFileList, dataType) {
			let _url = "/business/projectmonthlyreportinfo/saveBatch";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					records: weekFileList
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.getProjectMonthlyReportDetail()
				}
			});
		},
		getWeeklySituationList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/getWeeklySituationList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.comSituationList = data.body.comSituationList
					this.dataForm.stopPointList = data.body.stopPointList
					this.dataForm.inspectionSituationList = data.body.inspectionSituationList
					this.dataForm.progressKindList = data.body.progressKindList
					this.dataForm.hseRecordList = data.body.hseRecordList
					this.dataForm.opinionList = data.body.opinionList
					this.dataForm.onsitePersonalList = data.body.onsitePersonalList
					this.dataForm.keyWorkPlansList = data.body.keyWorkPlansList
					this.dataForm.meetingList = data.body.meetingList
					this.dataForm.fileCheckRecords = data.body.fileCheckRecords
					this.dataForm.contactAndNoticeList = data.body.contactAndNoticeList
					this.dataForm.photoList = data.body.photoList
				}
			});
		},
		saveMeetingFiles(meetIds) {
			// 计算最大排序值
			let sort = 0;
			let meetingList = this.dataForm.meetingList
			if (meetingList != undefined && meetingList.length > 0) {
				for (var i = 0; i < meetingList.length; i++) {
					if (meetingList[i].sort > sort) {
						sort = meetingList[i].sort
					}
				}
			}
			let _url = "/business/projectmonthlyreportfile/saveMeetingFiles";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					monthlyRecNo: this.recNo,
					meetIds: meetIds,
					sort: sort + 1
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getProjectMonthlyReportDetail();
				}
			});
		},
		getWeeklyMeetingList() {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportinfo/getWeeklyMeetingList/" + this.recNo,
				method: "get",
				params: {
				},
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.dataForm.meetingList = data.body
				}
			});
		},
		monthlyReportSort(fileList) {
			this.$http({
				url: this.$store.state.httpUrl + "/business/projectmonthlyreportfile/sort",
				method: "post",
				data: this.$http.adornData({
					dataType: this.updateDataType,
					monthlyRecNo: this.recNo,
					fileList: fileList
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
						onClose: () => {
							this.updateDataType = ''
							this.getProjectMonthlyReportDetail();
						}
					});
				}
			});
		},
		deleteMonthlyReportFile(recNo, dataType) {
			this.$confirm(`确定对选中的数据进行删除操作?`, '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.$http({
					url: this.$store.state.httpUrl + "/business/projectmonthlyreportfile/delete/" + recNo,
					method: "post",
					data: {},
				}).then(({ data }) => {
					if (data && data.resultCode === 200) {
						this.$message({
							message: '操作成功',
							type: 'success',
							duration: 1500,
							onClose: () => {
								// this.getWeeklySituationList()
								this.getProjectMonthlyReportDetail()
							}
						})
					}
				});
			})
		},
		addOrUpdateMeeting(recNo) {
			// 计算最大排序值
			let sort = 0;
			let meetingList = this.dataForm.meetingList
			if (meetingList != undefined && meetingList.length > 0) {
				for (var i = 0; i < meetingList.length; i++) {
					if (meetingList[i].sort > sort) {
						sort = meetingList[i].sort
					}
				}
			}
			this.addOrUpdateMeetingVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdateMeeting.init(this.recNo, recNo, sort + 1)
			})
		},
		addOrUpdateSituation(recNo, dataType, progressKindName) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.addOrUpdateSituationVisible = true;
			this.$nextTick(() => {
				this.$refs.addOrUpdateSituation.init(this.recNo, recNo, sort + 1, dataType, progressKindName)
			})
		},
		getMaxSort(dataType) {
			// 计算最大排序值
			let sort = 0;
			if (dataType === '000001' && this.dataForm.planCompleteList != undefined && this.dataForm.planCompleteList.length > 0) {
				for (var i = 0; i < this.dataForm.planCompleteList.length; i++) {
					if (this.dataForm.planCompleteList[i].sort > sort) {
						sort = this.dataForm.planCompleteList[i].sort
					}
				}
			} else if (dataType === '000002' && this.dataForm.actualCompleteList != undefined && this.dataForm.actualCompleteList.length > 0) {
				for (var i = 0; i < this.dataForm.actualCompleteList.length; i++) {
					if (this.dataForm.actualCompleteList[i].sort > sort) {
						sort = this.dataForm.actualCompleteList[i].sort
					}
				}
			} else if (dataType === '000003' && this.dataForm.causeAnalysisList != undefined && this.dataForm.causeAnalysisList.length > 0) {
				for (var i = 0; i < this.dataForm.causeAnalysisList.length; i++) {
					if (this.dataForm.causeAnalysisList[i].sort > sort) {
						sort = this.dataForm.causeAnalysisList[i].sort
					}
				}
			} else if ((dataType === '000401' || dataType === '000402' || dataType === '000400') && this.dataForm.specialAndMeetList != undefined && this.dataForm.specialAndMeetList.length > 0) {
				for (var i = 0; i < this.dataForm.specialAndMeetList.length; i++) {
					if (this.dataForm.specialAndMeetList[i].sort > sort) {
						sort = this.dataForm.specialAndMeetList[i].sort
					}
				}
			} else if (dataType === '000005' && this.dataForm.qualityVisaList != undefined && this.dataForm.qualityVisaList.length > 0) {
				for (var i = 0; i < this.dataForm.qualityVisaList.length; i++) {
					if (this.dataForm.qualityVisaList[i].sort > sort) {
						sort = this.dataForm.qualityVisaList[i].sort
					}
				}
			} else if ((dataType === '000601' || dataType === '000602' || dataType === '000600') && this.dataForm.issueContactAndNoticeList != undefined && this.dataForm.issueContactAndNoticeList.length > 0) {
				for (var i = 0; i < this.dataForm.issueContactAndNoticeList.length; i++) {
					if (this.dataForm.issueContactAndNoticeList[i].sort > sort) {
						sort = this.dataForm.issueContactAndNoticeList[i].sort
					}
				}
			} else if (dataType === '000007' && this.dataForm.anyReportList != undefined && this.dataForm.anyReportList.length > 0) {
				for (var i = 0; i < this.dataForm.anyReportList.length; i++) {
					if (this.dataForm.anyReportList[i].sort > sort) {
						sort = this.dataForm.anyReportList[i].sort
					}
				}
			} else if (dataType === '000008' && this.dataForm.paymentVisaList != undefined && this.dataForm.paymentVisaList.length > 0) {
				for (var i = 0; i < this.dataForm.paymentVisaList.length; i++) {
					if (this.dataForm.paymentVisaList[i].sort > sort) {
						sort = this.dataForm.paymentVisaList[i].sort
					}
				}
			} else if (dataType === '050100' && this.dataForm.stopPointList != undefined && this.dataForm.stopPointList.length > 0) {
				for (var i = 0; i < this.dataForm.stopPointList.length; i++) {
					if (this.dataForm.stopPointList[i].sort > sort) {
						sort = this.dataForm.stopPointList[i].sort
					}
				}
			} else if (dataType === '050200' && this.dataForm.inspectionSituationList != undefined && this.dataForm.inspectionSituationList.length > 0) {
				for (var i = 0; i < this.dataForm.inspectionSituationList.length; i++) {
					if (this.dataForm.inspectionSituationList[i].sort > sort) {
						sort = this.dataForm.inspectionSituationList[i].sort
					}
				}
			} else if (dataType === '050300' && this.dataForm.contactAndNoticeList != undefined && this.dataForm.contactAndNoticeList.length > 0) {
				for (var i = 0; i < this.dataForm.contactAndNoticeList.length; i++) {
					if (this.dataForm.contactAndNoticeList[i].sort > sort) {
						sort = this.dataForm.contactAndNoticeList[i].sort
					}
				}
			} else if (dataType === '050400' && this.dataForm.fileCheckRecords != undefined && this.dataForm.fileCheckRecords.length > 0) {
				for (var i = 0; i < this.dataForm.fileCheckRecords.length; i++) {
					if (this.dataForm.fileCheckRecords[i].sort > sort) {
						sort = this.dataForm.fileCheckRecords[i].sort
					}
				}
			} else if (dataType === '050500' && this.dataForm.meetingList != undefined && this.dataForm.meetingList.length > 0) {
				for (var i = 0; i < this.dataForm.meetingList.length; i++) {
					if (this.dataForm.meetingList[i].sort > sort) {
						sort = this.dataForm.meetingList[i].sort
					}
				}
			} else if (dataType === '111111' && this.dataForm.workSummaryList != undefined && this.dataForm.workSummaryList.length > 0) {
				for (var i = 0; i < this.dataForm.workSummaryList.length; i++) {
					if (this.dataForm.workSummaryList[i].sort > sort) {
						sort = this.dataForm.workSummaryList[i].sort
					}
				}
			} else if (dataType === '222222' && this.dataForm.nextMonthWorkPlanList != undefined && this.dataForm.nextMonthWorkPlanList.length > 0) {
				for (var i = 0; i < this.dataForm.nextMonthWorkPlanList.length; i++) {
					if (this.dataForm.nextMonthWorkPlanList[i].sort > sort) {
						sort = this.dataForm.nextMonthWorkPlanList[i].sort
					}
				}
			} else if (dataType.startsWith("22")) {
				for (var i = 0; i < this.dataForm.progressKindList.length; i++) {
					let progressKind = this.dataForm.progressKindList[i];
					if (progressKind.dataType == dataType && progressKind.recordAndTableList != undefined && progressKind.recordAndTableList.length > 0) {
						for (var j = 0; j < progressKind.recordAndTableList.length; j++) {
							let recordAndTable = progressKind.recordAndTableList[j];
							sort = recordAndTable.sort
						}
					}
				}
			}
			return sort;
		},
		searchQualityVisa(descRecNo) {
			this.searchQualityVisaVisible = true;
			this.$nextTick(() => {
				this.$refs.searchQualityVisa.init(this.recNo, descRecNo)
			})
		},
		objectNodeSpanMethod({ row, column, rowIndex, columnIndex }, tableData) {
			if (columnIndex === 0) {
				// this.tableData  修改
				const _row = (this.flitterNodeSubjectNo(tableData).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			} else if (columnIndex === 1) {
				// this.tableData  修改
				const _row = (this.flitterNodeData(tableData).one)[rowIndex];
				const _col = _row > 0 ? 1 : 0;
				return {
					rowspan: _row,
					colspan: _col
				};
			}
		},
		flitterNodeSubjectNo(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.subjectName === arr[index - 1].subjectName) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		flitterNodeData(arr) {
			let spanOneArr = []
			let concatOne = 0
			arr.forEach((item, index) => {
				if (index === 0) {
					spanOneArr.push(1);
				} else {
					//name 修改
					if (item.title === arr[index - 1].title) { //第一列需合并相同内容的判断条件
						spanOneArr[concatOne] += 1;
						spanOneArr.push(0);
					} else {
						spanOneArr.push(1);
						concatOne = index;
					};
				}
			});
			return {
				one: spanOneArr,
			}
		},
		chooseProgressKindHandle(dataType, progressKindId, progressKindName) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.chooseProgressKindVisible = true;
			this.$nextTick(() => {
				this.$refs.chooseProgressRecord.init(this.recNo, sort + 1, dataType, progressKindId, progressKindName, this.dataForm.beginTime, this.dataForm.endTime)
			})
		},
		lastRecordRefHandle(dataType, progressKindName) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.refDataType = dataType;
			this.lastRecordRefVisible = true;
			this.$nextTick(() => {
				this.$refs.lastRecordRef.init(this.recNo, sort + 1, dataType, progressKindName)
			})
		},
		addSummaryHandle() {
			let _url = "/business/projectmonthlyreportfile/saveContactAndNoticeSummary";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: this.recNo,
					workNo: $common.getItem("workNo"),
					endTime: this.dataForm.endTime
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getProjectMonthlyReportDetail()
					// this.getWeeklySituationList();
				}
			});
		},
		getProgressKindProgressNoList(dataType) {
			let progressNoList = []
			for (var i = 0; i < this.dataForm.progressKindList.length; i++) {
				let progressKind = this.dataForm.progressKindList[i];
				if (progressKind.dataType == dataType) {
					for (var j = 0; j < progressKind.recordAndTableList.length; j++) {
						let recordAndTable = progressKind.recordAndTableList[j];
						if (recordAndTable.dataKind != undefined && recordAndTable.dataKind != '' && recordAndTable.dataKind == '2'
							&& recordAndTable.showTable != undefined && recordAndTable.showTable != '' && recordAndTable.showTable == '3'
						) {
							// 表格数据
							progressNoList.push(recordAndTable.conProgress.progressNo);
						}
					}
				}
			}
			return progressNoList;
		},
		addProgressKindTableHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let progressNoList = this.getProgressKindProgressNoList(dataType);
			this.addProgressKindTableVisible = true;
			this.$nextTick(() => {
				this.$refs.addProgressTable.init(this.recNo, sort + 1, dataType, progressNoList)
			})
		},
		addStopPointTableHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let _url = "/business/projectmonthlyreportfile/saveReportFile";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: '',
					monthlyRecNo: this.recNo,
					dataType: dataType,
					dataKind: '2',
					sourceId: '',
					sourceType: '',
					sort: sort + 1,
					fileName: '',
					updUserName: $common.getItem("userName"),
					sourceType: '',
					showTable: '1',
					sourceId: ''
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					// this.getWeeklySituationList();
					this.getProjectMonthlyReportDetail();
				}
			});
		},
		addProgressRecordHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let _url = "/business/projectmonthlyreportfile/saveReportFile";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: '',
					monthlyRecNo: this.recNo,
					dataType: dataType,
					dataKind: '2',
					sourceId: '',
					sourceType: '',
					sort: sort + 1,
					fileName: '',
					updUserName: $common.getItem("userName"),
					sourceType: '',
					showTable: '4',
					sourceId: ''
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getProjectMonthlyReportDetail();
				}
			});
		},
		addInspectionTableHandle(dataType) {
			let sort = this.getMaxSort(dataType);
			let _url = "/business/projectmonthlyreportfile/saveReportFile";
			this.$http({
				url: this.$store.state.httpUrl + _url,
				method: "post",
				data: this.$http.adornData({
					recNo: '',
					monthlyRecNo: this.recNo,
					dataType: dataType,
					dataKind: '2',
					sourceId: '',
					sourceType: '',
					sort: sort + 1,
					fileName: '',
					updUserName: $common.getItem("userName"),
					sourceType: '',
					showTable: '2',
					sourceId: ''
				})
			}).then(({ data }) => {
				if (data && data.resultCode === 200) {
					this.$message({
						message: "操作成功",
						type: "success",
						duration: 1500,
					});
					this.getProjectMonthlyReportDetail();
				}
			});
		},
		chooseContactHandle(dataType, fileKind) {
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			// 获取附件监理联系单来源ids
			let fileIds = ''
			// let contactAndNoticeList = this.dataForm.contactAndNoticeList
			// if (contactAndNoticeList != undefined && contactAndNoticeList.length > 0) {
			// 	for (var i = 0; i < contactAndNoticeList.length; i++) {
			// 		if (contactAndNoticeList[i].sourceType === '4' && contactAndNoticeList[i].sourceId != undefined && contactAndNoticeList[i].sourceId != '') {
			// 			fileIds = fileIds + contactAndNoticeList[i].sourceId
			// 			if (i < contactAndNoticeList.length - 1) {
			// 				fileIds = fileIds + ','
			// 			}
			// 		}
			// 	}
			// }
			this.chooseContactVisible = true;
			this.$nextTick(() => {
				this.$refs.chooseContact.init(this.recNo, sort + 1, dataType, fileKind, this.dataForm.beginTime, this.dataForm.endTime, fileIds)
			})
		},
		onDragStart(dataType) {
			this.updateDataType = dataType;
		},
		onDragEnd(event) {
			event.preventDefault();
			// 拖拽结束后的处理逻辑
			let records = [];
			if (this.updateDataType == '000001') {
				// 计划完成
				records = this.dataForm.planCompleteList
			} else if (this.updateDataType == '000002') {
				// 实际完成
				records = this.dataForm.actualCompleteList
			} else if (this.updateDataType == '000003') {
				// 原因分析
				records = this.dataForm.causeAnalysisList
			} else if (this.updateDataType == '000401' || this.updateDataType == '000402' || this.updateDataType == '000400') {
				// 专题报告/会议纪要
				records = this.dataForm.specialAndMeetList
			} else if (this.updateDataType == '000005') {
				// 质量签证
				records = this.dataForm.qualityVisaList
			} else if (this.updateDataType === '000601' || this.updateDataType === '000602' || this.updateDataType == '000600') {
				// 向建造单位发出的通知、指示
				records = this.dataForm.issueContactAndNoticeList
			} else if (this.updateDataType == '000007') {
				// 建造单位提出的各种报告
				records = this.dataForm.anyReportList
			} else if (this.updateDataType == '000008') {
				// 付款签证
				records = this.dataForm.paymentVisaList
			} else if (this.updateDataType == '050100') {
				// 五、本周质量情况  1.停止点检查情况：
				records = this.dataForm.stopPointList
			} else if (this.updateDataType == '050200') {
				// 五、本周质量情况 2.巡检情况：
				records = this.dataForm.inspectionSituationList
			} else if (this.updateDataType == '050300') {
				// 五、本周质量情况 3.监理工作联系单和通知单（不一致项报告）处理及跟踪情况：
				records = this.dataForm.contactAndNoticeList
			} else if (this.updateDataType == '050400') {
				// 五、本周质量情况 4.签收及审查文件情况：
				records = this.dataForm.fileCheckRecords
			} else if (this.updateDataType == '050500') {
				// 五、本周质量情况 5.会议及会谈情况
				records = this.dataForm.meetingList
			} else if (this.updateDataType == '111111') {
				// 本月监理工作小结
				records = this.dataForm.workSummaryList
			} else if (this.updateDataType == '222222') {
				// 下月监理工作安排
				records = this.dataForm.nextMonthWorkPlanList
			} else if (this.updateDataType.startsWith('22') && this.updateDataType != '222222') {
				var progressKindList = this.dataForm.progressKindList;
				for (var i = 0; i < this.dataForm.progressKindList.length; i++) {
					if (this.updateDataType == progressKindList[i].dataType) {
						records = progressKindList[i].recordAndTableList;
					}
				}
			}
			this.monthlyReportSort(records)
		},
		viewEnclosureFile(url, filename) {
			filename = this.getSuffix(url, filename)
			this.getBlob(url, (blob) => {
				this.saveAs(blob, filename)
			})
		},
		getSuffix(url, filename) {
			let lastIndex = url.lastIndexOf(".");
			return filename + url.substr(lastIndex)
		},
		getBlob(url, cb) {
			var xhr = new XMLHttpRequest()
			xhr.open('GET', url, true)
			xhr.responseType = 'blob'
			xhr.onload = function () {
				if (xhr.status === 200) {
					cb(xhr.response)
				}
			}
			xhr.send()
		},
		saveAs(blob, filename) {
			if (window.navigator.msSaveOrOpenBlob) {
				navigator.msSaveBlob(blob, filename)
			}
			else {
				var link = document.createElement('a')
				var body = document.querySelector('body')

				link.href = window.URL.createObjectURL(blob)
				link.download = filename

				link.style.display = 'none'
				body.appendChild(link)

				link.click()
				body.removeChild(link)
				window.URL.revokeObjectURL(link.href)
			}
		},
		selectSpecialReportHandle(dataType) {
			this.specialReportSelectVisible = true
			// 获取专题报告来源ids
			let recIds = ''
			let specialAndMeetList = this.dataForm.specialAndMeetList
			if (specialAndMeetList != undefined && specialAndMeetList.length > 0) {
				for (var i = 0; i < specialAndMeetList.length; i++) {
					if (specialAndMeetList[i].sourceType === '5') {
						recIds = recIds + specialAndMeetList[i].sourceId
						if (i < specialAndMeetList.length - 1) {
							recIds = recIds + ','
						}
					}
				}
			}
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.$nextTick(() => {
				this.$refs.specialReportSelect.init(this.dataForm.beginTime, this.dataForm.endTime, recIds, this.recNo, dataType, sort + 1)
			})
		},
		selectContactHandle(dataType, fileKind) {
			this.selectContactVisible = true
			// 获取ids
			let recIds = ''
			let issueContactAndNoticeList = this.dataForm.issueContactAndNoticeList
			if (issueContactAndNoticeList != undefined && issueContactAndNoticeList.length > 0) {
				for (var i = 0; i < issueContactAndNoticeList.length; i++) {
					if ((issueContactAndNoticeList[i].sourceType === '6' && fileKind == '2') || issueContactAndNoticeList[i].sourceType === '4' && fileKind == '1') {
						recIds = recIds + issueContactAndNoticeList[i].sourceId
						if (i < issueContactAndNoticeList.length - 1) {
							recIds = recIds + ','
						}
					}
				}
			}
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.$nextTick(() => {
				this.$refs.contactSelect.init(this.recNo, sort + 1, dataType, fileKind, this.dataForm.beginTime, this.dataForm.endTime, recIds)
			})
		},
		selectMeetInfoHandle(dataType) {
			this.meetInfoSelectVisible = true
			// 获取会议纪要来源ids
			let recIds = ''
			let specialAndMeetList = this.dataForm.specialAndMeetList
			if (specialAndMeetList != undefined && specialAndMeetList.length > 0) {
				for (var i = 0; i < specialAndMeetList.length; i++) {
					if (specialAndMeetList[i].sourceType === '3') {
						recIds = recIds + specialAndMeetList[i].sourceId
						if (i < specialAndMeetList.length - 1) {
							recIds = recIds + ','
						}
					}
				}
			}
			// 计算最大排序值
			let sort = this.getMaxSort(dataType);
			this.$nextTick(() => {
				this.$refs.meetInfoSelect.init(this.dataForm.beginTime, this.dataForm.endTime, recIds, this.recNo, dataType, sort + 1)
			})
		},
		selectMeetingHandle(dataType) {
			this.meetingSelectVisible = true
			this.meetDataType = dataType
			// 获取附件监理联系单来源ids
			let meetIds = ''
			// 会议模块
			if (dataType === '050500') {
				let meetingList = this.dataForm.meetingList
				if (meetingList != undefined && meetingList.length > 0) {
					for (var i = 0; i < meetingList.length; i++) {
						if (meetingList[i].sourceId != null && meetingList[i].sourceId != '') {
							meetIds = meetIds + meetingList[i].sourceId
							if (i < meetingList.length - 1) {
								meetIds = meetIds + ','
							}
						}
					}
				}
			}
			this.$nextTick(() => {
				this.$refs.meetingSelect.init(this.dataForm.beginTime, this.dataForm.endTime, meetIds, dataType)
			})
		},
		// selectMeetingEnclosureFile(dataType) {
		// 	this.meetingSelectVisible = true
		// 	this.meetDataType = dataType
		// 	// 获取附件监理联系单来源ids
		// 	let meetIds = ''
		// 	// 会议模块
		// 	if (dataType === '080000') {
		// 		let enclosureFileList = this.dataForm.enclosureFileList
		// 		if (enclosureFileList != undefined && enclosureFileList.length > 0) {
		// 			for (var i = 0; i < enclosureFileList.length; i++) {
		// 				if (enclosureFileList[i].dataType === '080000' && enclosureFileList[i].sourceType === '3') {
		// 					meetIds = meetIds + enclosureFileList[i].sourceId
		// 					if (i < enclosureFileList.length - 1) {
		// 						meetIds = meetIds + ','
		// 					}
		// 				}
		// 			}
		// 		}
		// 	}
		// 	this.$nextTick(() => {
		// 		this.$refs.meetingSelect.init(this.dataForm.beginTime, this.dataForm.endTime, meetIds, dataType)
		// 	})
		// },
		margeSelectMeetingItems(items) {
			this.meetingSelectVisible = false;
			if (this.meetDataType === '050500') {
				let meetIds = items.map((item) => item.meetId);
				this.saveMeetingFiles(meetIds)
			}
			this.meetDataType = ''
		},
		headClass() {
			return 'background:#E1F1FF;color:#00428E;border:solid #dadada 1px;padding:1px;font-size:12px'
		},
	},
};
</script>
<style lang="scss" scoped="scoped">
.elCardTitle {
	color: black !important;
	font-size: 15px;
	border-bottom: 1px solid black;
}

.border-form .el-row.set_border {
	border: solid #dadada 1px;
	border-top: 0px
}

.border-form .el-row.set_border:first-child {
	border-top: solid #dadada 1px;
}

.border-form .el-row.set_border .col-set_border {
	border-right: solid #dadada 1px;
}

.col-set_border1 {
	border: solid #dadada 1px;
}

.col-set_border2 {
	border: solid #dadada 1px;
	border-left: solid #dadada 0px;
}

.col-set_border3 {
	border: solid #dadada 1px;
	border-top: solid #dadada 0px;
}

.col-set_border4 {
	border-right: solid #dadada 1px;
	border-bottom: solid #dadada 1px;
}

.item::v-deep .el-form-item__label {
	color: #00428E !important;
	margin-right: 10px !important;
	font-weight: bold !important;
	background-color: #E1F1FF;
	white-space: nowrap !important;
	border-right: solid #dadada 1px;
	font-size: 13px !important;
}

::v-deep .el-form-item {
	display: flex !important;
	align-items: stretch !important;
	margin-bottom: 0px !important;
}

.summaryLabelspan {
	display: inline-block;
	color: black;
	width: 250px !important;
	padding-left: 10px;
	font-size: 13px;
	margin-bottom: -10px;
	margin-right: 30px;
	margin-left: 5px;
}

.statusSpan {
	width: 232px !important;
	margin-left: 23px
}

.summaryLabelspan1 {
	display: inline-block;
	// margin-left: 10px;
	color: #00428E;
	border: solid #dadada 1px;
	border-bottom: solid #dadada 0px;
	padding-left: 10px;
	font-size: 13px;
	margin-right: 30px;
	// width: 1095%;
}

.contact_col {
	border: 1px solid rgba(235, 238, 240, 1);
	//  border: solid #dadada 1px;
	color: #00428E;
	//  padding-top: -10px !important;
	padding-left: 15px;
	height: 40px;
}

.titleDiv {
	background-color: #E1F1FF;
	font-size: 15px;
	margin-top: 20px;
	margin-bottom: 12px;
	padding: 10px 0px 10px 10px;
	font-weight: bolder;
}

.titleDiv_second {
	background-color: #E1F1FF;
	font-size: 15px;
	padding: 10px 0px 10px 10px;
	font-weight: bolder;
}

.seTitleDiv {
	font-size: 13px;
	font-weight: bolder;
	margin-left: 10px;
	// border-bottom: 1px solid #E1F1FF;
	background-color: #f9f3f39c;
	// background-color: red;
	height: 30px;
	padding: 7px 0px 5px 5px;
}

::v-deep(.el-form-item__content) {
	flex: 1 !important;
	width: 100% !important;
}

::v-deep(.sp-input) {
	width: 100% !important;
	display: block !important;
	font-size: 13px !important;
}

::v-deep(.sp-input .el-input__inner) {
	width: 100% !important;
	box-sizing: border-box !important;
}

::v-deep .title_item .el-form-item__content {
	line-height: 25px !important;
}

::v-deep .desc_input .el-input__inner {
	border-radius: 0px;
	border-width: 0px;
	width: 100% !important;
	white-space: pre-wrap !important;
	overflow-wrap: break-word !important;
	// white-space: pre-line !important;
	color: black;
	padding: 0px !important;
	margin-top: -10px;
	font-size: 14px;
	margin-top: 1px;
	// border-bottom: solid #dadada 1px;
}

.desc_span {
	padding-top: 2px;
	line-height: 22px;
	border-bottom: solid transparent 1px;
	white-space: pre-line;
	text-align: left !important;
	font-size: 13px;
}

.desc_span_color {
	border-bottom: solid transparent 1px;
	white-space: pre-line
}

::v-deep .desc_input_color .el-input__inner {
	border-radius: 0px;
	border-width: 0px;
	width: 100% !important;
	white-space: pre-line;
	color: black;
	padding: 0px !important;
	margin-top: -10px;
	font-size: 14px;
	background-color: #e1f1ff !important;
	height: 30px;
}

.un_col {
	border: 1px solid transparent;
	text-align: center;
	margin-top: -5px;
	// font-size: 13px;
}

.un_span {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: #169BD5;
}

.desc_btn {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: #169BD5;
	margin-top: -8px;
}

.cp_sub_row {
	// border-bottom: 1px solid #00428E;
	font-size: 13px;
	background-color: rgb(204, 247, 176);
	padding: 10px;
	color: #00428E;
}

.cp_maj_row {
	color: #00428E;
	background-color: #a9ccf5;
	padding: 10px;
	border-top: 1px solid #00428E;
}

.cp_sc_div {
	// border: 1px solid rgba(235, 238, 240, 1); 
	// border-bottom: 0px;
	padding: 10px 20px 10px 10px;
	margin-left: 10px;
	margin-top: 5px;
	font-weight: bold;
	font-size: 13px;
	height: 30px;
	display: flex;
	/* 弹性布局 */
	justify-content: space-between;
	/* 左右分开 */
	align-items: center;
	/* 垂直居中 */
}

.el-icon-position {
	margin: 14px;
}

.tr_title_row {
	border: 1px solid rgba(235, 238, 240, 1);
	font-weight: bolder;
	color: #00428E;
	font-size: 14px;
	padding: 15px;
}

.tr_title_row1 {
	font-size: 14px;
	padding: 15px;
}

.tr_qp_row {
	border: 1px solid rgba(235, 238, 240, 1);
	font-weight: bolder;
	font-size: 14px;
	padding: 15px;
	text-align: center
}

.cv_span {
	display: inline-block;
	width: 70px;
	text-align: center;
	background-color: #dadada;
	margin-left: 10px;
	margin-right: 10px;
}

.addImgBox {
	width: 180px;
	height: 180px;
	display: inline-block;
	vertical-align: middle;
	margin-right: 23px;
}

// .image {
// 	width: 80%;
// 	height: 200px;
// 	margin-top: 5px;
// 	display: block;
// }

.photo_row {
	border: 1px solid rgba(235, 238, 240, 1);
	width: 80%;
	padding-bottom: 20px;
	padding-top: 20px;
	margin-top: 10px
}

.meet_row {
	// border: 1px solid rgba(235, 238, 240, 1);
	width: 100%;
	padding-bottom: 20px;
	padding-top: 20px;
	margin-top: 10px
}

.photo_col {
	border: 1px solid rgba(235, 238, 240, 1);
}

.set_bc {
	border-bottom: solid #dadada 1px;
	background-color: #e1f1ff !important;
	// height:35px !important;
	padding-top: 8px;
	padding-left: 5px;
}

.set_nonS {
	border-bottom: solid #dadada 1px;
	min-height: 28px !important;
	padding-top: 8px;
	padding-left: 5px;
}

.mc_div {
	margin-left: 20px;
	border: 1px solid rgba(235, 238, 240, 1);
	padding: 10px;
	width: 90%;
	margin-bottom: -20px
}

::v-deep .desc_input1 .el-textarea__inner {
	// padding-right: 50px !important;
	border: 0px;
	color: black;
	resize: none;
}

::v-deep .desc_input_bc .el-textarea__inner {
	// padding-right: 50px !important;
	border: 0px;
	color: black;
	background-color: #e1f1ff;
	resize: none;
}

.set_span {
	display: block;
	font-size: 13px;
	/* 将span转换为块级元素 */
	max-width: 275px;
	/* 设置固定长度 */
	white-space: nowrap;
	/* 不换行 */
	overflow: hidden;
	/* 超出部分隐藏 */
	text-overflow: ellipsis;
	/* 超出部分显示省略号 */
	cursor: default;
	/* 将鼠标光标设置为默认样式 */
}

.desc_zw {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: white;
}

.desc_zw_bc {
	font-weight: 400;
	font-style: normal;
	font-size: 13px;
	color: #e1f1ff;
}

.sesit {
	margin-left: 15px;
	margin-bottom: 10px;
	margin-top: 10px;
}

/* 表格无数据时：彻底清除所有边框、下划线 */
.no-data-table {
	border: none !important;
}

.no-data-table::before {
	display: none !important;
}

.no-data-table .el-table__empty-block {
	border-bottom: none !important;
}

.no-data-table .el-table__inner-wrapper::before {
	display: none !important;
}

.operate_col {
	margin-left: 3.5%;
}

table {
	margin-top: 10px;
	border-collapse: collapse;
	width: 100%;
}

th,
td {
	border: 1px solid #dadada;
	padding: 2px;
	text-align: center;
	font-size: 14px !important;
}

.sit_label {
	padding: 5px;
}

.fixed-number-row {
	height: 32px !important;
	min-height: 32px !important;
	max-height: 32px !important;
	overflow: hidden !important;
}

::v-deep .monthly-input .el-input__inner {
	height: 26px !important;
	line-height: 26px !important;
	padding: 0 8px !important;
	/* 留一点内边距，文字不贴边 */
	border: 1px solid #DCDFE6 !important;
	/* 强制显示边框 */
	border-radius: 4px !important;
	box-sizing: border-box !important;
}

.mod_span {
	font-size: 13px;
}

.selBtnGroup {
	margin-top: 5px;
	margin-bottom: 5px;
	margin-right: 20px !important;
}
</style>